/**
 * @file
 * Utils file for all Javascript.
 */
(function($, Drupal) {
    /*
     * For global debug. For specific debug : change only the debug on the
     * concerned behavior.
     */
    const DEBUG = false;

    $.extend(Drupal.theme, {
        DEBUG: DEBUG,

        BREAKPOINTS: {
            xScreen: 2000, // Max width possible
            screen: 1100, // Small screens
            tab: 992, // Tablet
            mob: 800, // Mobiles
            xMob: 600, // Small mobiles
            xxMob: 340, // Very small mobiles
        },

        SELECTORS: {
            $window: $(window),
            $html: $('html'),
            $body: $('body'),
        },

        COLORS: {
            BLACK: '\x1B[30m',
            RED: '\x1B[31m',
            GREEN: '\x1B[32m',
            YELLOW: '\x1B[33m',
            BLUE: '\x1B[34m',
            MAGENTA: '\x1B[35m',
            CYAN: '\x1B[36m',
            WHITE: '\x1B[37m',
            GRAY: '\x1B[90m',
        },

        PATH: '/themes/custom/opera_limoges/',

        /**
         * Logging function
         *
         * @param {Boolean} debug
         * @param {string} color
         * @param {string} namespace
         * @param {array} args
         */
        log(debug, color, namespace, args) {
            if (DEBUG || debug) {
                console.log(
                    color + namespace + '\x1b[0m',
                    ...args
                );
            }
        },
    });
})(jQuery, Drupal);
